module.exports = __webpack_public_path__ + "static/media/logo.3881df12.svg";